import { createTypes, actionCreator } from 'redux-action-creator';
import { parseJSON, handleNetworkError } from '../../utils'


export const jobsTypes = createTypes(['REQUEST', 'RECEIVE', 'ERROR', 'SUCCESS'], 'JOBS');


export const requestJobs = () => {
    return {
        type: jobsTypes.REQUEST,
    };
};

export const receiveJobs = (response) => {
    return {
        type: jobsTypes.RECEIVE,
        data: response,
    };
};

export const receiveJobsError = (response) => {
    return {
        type: jobsTypes.ERROR,
        error: response,
    };
};

export const fetchJobs = () => {
    return dispatch => {
        let apiUrl = `/api/v1/jobs/`

        dispatch(requestJobs());

        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }

        return fetch(apiUrl, {
            headers: headers,
        })
        .then(parseJSON)
        .then(response => {
            try {
                dispatch(receiveJobs(response));
            } catch (e) {
                dispatch(receiveJobsError(response));
            }
        })
        .catch(handleNetworkError);
    };
};